import {
  DEFAULT_APP_LANGUAGE,
  LAUNCH_UI_ENGLISH_ONLY,
  isLaunchUiEnglishOnly,
  isSupportedAppLanguage,
  SUPPORTED_APP_LANGUAGES,
  getAppLanguageAuthChipOptions,
  getAppLanguageSettingsOptions,
} from './supportedLanguages.mjs';

/**
 * Map device locale tag (e.g. de-CH, fr-FR) to a supported app language or default.
 * @param {string | null | undefined} deviceTag
 */
export function mapDeviceLocaleToAppLanguage(deviceTag) {
  if (!deviceTag || typeof deviceTag !== 'string') return DEFAULT_APP_LANGUAGE;
  const normalized = deviceTag.trim().toLowerCase().replace(/_/g, '-');
  if (!normalized) return DEFAULT_APP_LANGUAGE;
  const base = normalized.split('-')[0];
  if (isSupportedAppLanguage(base)) return base;
  if (isSupportedAppLanguage(normalized)) return normalized;
  return DEFAULT_APP_LANGUAGE;
}

/**
 * Resolve active UI language from stored preference and device locale.
 * After login, callers should pass server `preferences.language` as `stored`.
 * @param {{ stored?: string | null, deviceTag?: string | null }} options
 */
export function resolveAppLanguage({ stored, deviceTag } = {}) {
  if (isLaunchUiEnglishOnly()) return DEFAULT_APP_LANGUAGE;
  if (isSupportedAppLanguage(stored)) return stored;
  const fromDevice = mapDeviceLocaleToAppLanguage(deviceTag);
  if (fromDevice !== DEFAULT_APP_LANGUAGE) return fromDevice;
  return DEFAULT_APP_LANGUAGE;
}

export {
  SUPPORTED_APP_LANGUAGES,
  DEFAULT_APP_LANGUAGE,
  LAUNCH_UI_ENGLISH_ONLY,
  isLaunchUiEnglishOnly,
  isSupportedAppLanguage,
  getAppLanguageAuthChipOptions,
  getAppLanguageSettingsOptions,
};
